<section class="fb-search-result overflow-x-hidden flex flex-col justify-start items-center min-h-[60vh]">
	<section class="container text-center flex flex-col justify-center items-stretch">
		<h1 class="p-2 mx-2 mt-16 mb-6 text-5xl tracking-wide capitalize font-medium">
			Search
		</h1>
		<span class="fb-font-tgl text-base">
			Please enter a search keyword, color or fabric to see search results displayed below.
		</span>
		<span *ngIf="!loading && searchFormControl.valid && ( searchFormControl.dirty || searchFormControl.touched ) && products.length > 0"
			  class="text-[#7D5B20] font-medium tracking-wide mt-2">
			Showing {{products.length}} products
		</span>
	</section>
	<section class="flex flex-col justify-center items-center py-8">
		<form [formGroup]="searchFormGroup"
			  (ngSubmit)="onSubmit()">
			<input class="fb-search-results-input rounded-xl"
				   type="text"
				   id="search"
				   name="searchResult"
				   [formControl]="searchFormControl"
				   autofocus
				   autocomplete="off"
				   placeholder="Search (keywords,etc)"
				   (paste)="getFilteredProducts()"
				   (change)="getFilteredProducts()"
				   (keyup)="getFilteredProducts()">
			<button type="submit" class="opacity-0" ></button>
		</form>
	</section>
	<section class="container">
		<ng-container *ngIf="!loading && searchFormControl.valid && ( searchFormControl.dirty || searchFormControl.touched )">
			<fb-search-products [products]="productListingForView"
								 class="py-3 md:py-5 mx-4 md:mx-0">
			</fb-search-products>

			<ng-container *ngIf="(products && products.length === 0)">
				<div class="container py-5 flex justify-center items-center">
					<img class="w-[250px] h-[250px]" src="assets/img/noproduct_placehlder.png" alt="product not found">
				</div>
			</ng-container>
		</ng-container>

		<section *ngIf="loading"
				 class="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 md:px-4 my-16 gap-5 mx-4 md:mx-0">
			<ng-container>
				<fb-skeleton-product-item class="my-2"></fb-skeleton-product-item>
				<fb-skeleton-product-item class="my-2"></fb-skeleton-product-item>
				<fb-skeleton-product-item class="my-2"></fb-skeleton-product-item>
				<fb-skeleton-product-item class="my-2"></fb-skeleton-product-item>
				<fb-skeleton-product-item class="my-2"></fb-skeleton-product-item>
				<fb-skeleton-product-item class="my-2"></fb-skeleton-product-item>
			</ng-container>
		</section>

		<div class="load_more_button_cont text-transparent" #testDiv>
			<button class="load_more" (click)="loadMoreClicked()"
					*ngIf=" (pageStartIndex+pageLength) < (products.length)">
				Load more
				<!-- ( startIndex-{{startIndex}},startIndexwithThree-{{startIndex+3}}, originalLen-{{productListing.length}},numberOfItemPerPage-{{numberOfItemPerPage}} )  {{(endIndex)*numberOfItemPerPage}} -->
			</button>
		</div>
	</section>
</section>
